const hideBtn = () => {
    if (location.pathname.includes('collections')) {
        const filterBtn = document.querySelector('.facet-filters accordion-list button');
        const clearBtn = document.querySelector('.clear-all--desktop');

        if (filterBtn && clearBtn) {
          filterBtn.addEventListener('click', () => {
            requestAnimationFrame(() => {
              const isActive = filterBtn.classList.contains('active');
              if (clearBtn) {
                clearBtn.classList.toggle('hide-btn', !isActive);
              }
            });
          });
        }
      }

}

export { hideBtn }